module.exports = "not implemented yet"


//////////////////
// WEBPACK FOOTER
// D:/www/kh_indesso_web/src/app/components/ingredient/ingredient/ingredient.component.html
// module id = ../../../../../src/app/components/ingredient/ingredient/ingredient.component.html
// module chunks = 0